import React from 'react';
import { toast } from 'sonner';

const MotorLaunchSettings = ({ formData, handleChange }) => {
  return (
    <div className="card">
      <div className="card-body">
        <h3 style={{ marginBottom: '1.5rem', fontSize: '1.25rem', fontWeight: 600 }}>
          🚤 Motor Bot Ücretleri
        </h3>
        <p style={{ color: '#64748b', marginBottom: '1.5rem' }}>
          Motor bot sefer ücretlerini demirsahası bölgelerine göre ayarlayın.
        </p>
        
        {/* Yeni Bölge Ekleme */}
        <div style={{ 
          background: '#f0fdf4', 
          padding: '1rem', 
          borderRadius: '8px',
          marginBottom: '1.5rem',
          border: '1px solid #86efac'
        }}>
          <h4 style={{ fontSize: '1rem', fontWeight: 600, marginBottom: '1rem', color: '#16a34a' }}>
            Yeni Bölge Ekle
          </h4>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr auto', gap: '1rem', alignItems: 'flex-end' }}>
            <div>
              <label style={{ fontSize: '0.75rem', fontWeight: 600, color: '#64748b', marginBottom: '0.25rem', display: 'block' }}>Türkçe Ad</label>
              <input
                type="text"
                className="form-input"
                placeholder="Örn: 2. Demirsahası"
                id="new_ml_name_tr"
              />
            </div>
            <div>
              <label style={{ fontSize: '0.75rem', fontWeight: 600, color: '#64748b', marginBottom: '0.25rem', display: 'block' }}>İngilizce Ad</label>
              <input
                type="text"
                className="form-input"
                placeholder="Örn: 2nd Anchorage"
                id="new_ml_name_en"
              />
            </div>
            <div>
              <label style={{ fontSize: '0.75rem', fontWeight: 600, color: '#64748b', marginBottom: '0.25rem', display: 'block' }}>Ücret (USD)</label>
              <input
                type="number"
                step="0.01"
                className="form-input"
                placeholder="0.00"
                id="new_ml_rate"
              />
            </div>
            <button
              type="button"
              onClick={() => {
                const nameTr = document.getElementById('new_ml_name_tr').value.trim();
                const nameEn = document.getElementById('new_ml_name_en').value.trim();
                const rate = parseFloat(document.getElementById('new_ml_rate').value) || 0;
                
                if (nameTr && nameEn) {
                  const newRate = {
                    id: nameTr.toLowerCase().replace(/\s+/g, '_'),
                    name_tr: nameTr,
                    name_en: nameEn,
                    rate: rate,
                    active: true
                  };
                  handleChange('motor_launch_rates', [...(formData.motor_launch_rates || []), newRate]);
                  document.getElementById('new_ml_name_tr').value = '';
                  document.getElementById('new_ml_name_en').value = '';
                  document.getElementById('new_ml_rate').value = '';
                  toast.success('Bölge eklendi');
                }
              }}
              style={{
                padding: '0.6rem 1.5rem',
                background: '#16a34a',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
                fontWeight: 600,
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem'
              }}
            >
              + Ekle
            </button>
          </div>
        </div>

        {/* Mevcut Bölgeler */}
        <div style={{ border: '1px solid #e2e8f0', borderRadius: '8px', overflow: 'hidden' }}>
          <div style={{ 
            background: '#f8fafc', 
            padding: '0.75rem 1rem', 
            fontWeight: 600, 
            fontSize: '0.9rem',
            borderBottom: '1px solid #e2e8f0',
            display: 'grid',
            gridTemplateColumns: '1fr 1fr 120px 80px 60px',
            gap: '1rem'
          }}>
            <span>Türkçe Ad</span>
            <span>İngilizce Ad</span>
            <span>Ücret (USD)</span>
            <span style={{ textAlign: 'center' }}>Aktif</span>
            <span style={{ textAlign: 'center' }}>Sil</span>
          </div>
          {(formData.motor_launch_rates || []).length === 0 ? (
            <div style={{ padding: '2rem', textAlign: 'center', color: '#9ca3af' }}>
              Henüz bölge eklenmedi
            </div>
          ) : (
            (formData.motor_launch_rates || []).map((rate, index) => (
              <div key={index} style={{ 
                padding: '0.75rem 1rem', 
                borderBottom: index < (formData.motor_launch_rates || []).length - 1 ? '1px solid #e2e8f0' : 'none',
                display: 'grid',
                gridTemplateColumns: '1fr 1fr 120px 80px 60px',
                gap: '1rem',
                alignItems: 'center',
                background: index % 2 === 0 ? '#fff' : '#f9fafb'
              }}>
                <input
                  type="text"
                  className="form-input"
                  value={rate.name_tr}
                  onChange={(e) => {
                    const updated = [...(formData.motor_launch_rates || [])];
                    updated[index].name_tr = e.target.value;
                    handleChange('motor_launch_rates', updated);
                  }}
                  style={{ margin: 0 }}
                />
                <input
                  type="text"
                  className="form-input"
                  value={rate.name_en}
                  onChange={(e) => {
                    const updated = [...(formData.motor_launch_rates || [])];
                    updated[index].name_en = e.target.value;
                    handleChange('motor_launch_rates', updated);
                  }}
                  style={{ margin: 0 }}
                />
                <input
                  type="number"
                  step="0.01"
                  className="form-input"
                  value={rate.rate}
                  onChange={(e) => {
                    const updated = [...(formData.motor_launch_rates || [])];
                    updated[index].rate = parseFloat(e.target.value) || 0;
                    handleChange('motor_launch_rates', updated);
                  }}
                  style={{ margin: 0 }}
                />
                <div style={{ textAlign: 'center' }}>
                  <input
                    type="checkbox"
                    checked={rate.active !== false}
                    onChange={(e) => {
                      const updated = [...(formData.motor_launch_rates || [])];
                      updated[index].active = e.target.checked;
                      handleChange('motor_launch_rates', updated);
                    }}
                    style={{ width: '18px', height: '18px', accentColor: '#10b981' }}
                  />
                </div>
                <div style={{ textAlign: 'center' }}>
                  <button
                    type="button"
                    onClick={() => {
                      if (window.confirm(`"${rate.name_tr}" bölgesini silmek istediğinize emin misiniz?`)) {
                        const updated = (formData.motor_launch_rates || []).filter((_, i) => i !== index);
                        handleChange('motor_launch_rates', updated);
                        toast.success('Bölge silindi');
                      }
                    }}
                    style={{
                      padding: '0.25rem 0.5rem',
                      background: '#ef4444',
                      color: 'white',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      fontSize: '0.75rem'
                    }}
                  >
                    ✗
                  </button>
                </div>
              </div>
            ))
          )}
        </div>

        {/* Ek Ücretler */}
        <div style={{ marginTop: '2rem', padding: '1.5rem', background: '#f0f9ff', borderRadius: '8px' }}>
          <h4 style={{ color: '#0369a1', marginBottom: '1rem' }}>Ek Demirsahası Ücretleri</h4>
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">2. Demirsahası Ek Ücret (USD)</label>
              <input
                type="number"
                step="0.01"
                className="form-input"
                value={formData.motor_launch_2nd_anchorage_rate || 0}
                onChange={(e) => handleChange('motor_launch_2nd_anchorage_rate', parseFloat(e.target.value) || 0)}
              />
            </div>
            <div className="form-group">
              <label className="form-label">3. Demirsahası Ek Ücret (USD)</label>
              <input
                type="number"
                step="0.01"
                className="form-input"
                value={formData.motor_launch_3rd_anchorage_rate || 0}
                onChange={(e) => handleChange('motor_launch_3rd_anchorage_rate', parseFloat(e.target.value) || 0)}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MotorLaunchSettings;
